import { gql } from '@apollo/client'

export const GET_COACH_ANALYTICS = gql`
  query CoachAnalytics($timeRange: PGACoachAnalyticsTimeRangeInput) {
    pgaCoachAnalytics(timeRange: $timeRange) {
      # Earnings analytics
      earnings {
        total
        byMonth {
          month
          total
        }
      }
      # Group events analytics
      groupEvents {
        revenue
        byMonth {
          month
          count
        }
        topEarningEvents(limit: 10) {
          groupEvent {
            id
            slug
            title
            description
            startDateTime
            timezone
            priceInCents
            tags
            academyRequired
            collectAttendance
            featuredImageUrl
            coachFacility {
              id
            }
            template {
              id
            }
          }
          earnings
          registrationCount
        }
      }
      # Leads analytics
      leads {
        totalCount
        unviewedCount
        convertedCount
        conversionRate
        byMonth {
          month
          count
        }
      }
      # Private lesson analytics
      privateLessonTypes {
        revenue
        totalTypes
        byMonth {
          month
          count
        }
        topBooked(limit: 10) {
          lessonType {
            id
            title
            deletedAt
          }
          lessonCount
          uniqueStudentCount
          earnings
        }
      }
    }
  }
`

export const GET_COACH_ANALYTICS_BENCHMARKS = gql`
  query CoachAnalyticsBenchmarks($timeRange: PGACoachAnalyticsTimeRangeInput) {
    pgaCoachAnalytics(timeRange: $timeRange) {
      billableHours
      utilizationPercent
      fullTimeProgressPercent
      fullTimeBarDollars
    }
  }
`

// Separate from GET_COACH_ANALYTICS so a backend without `otherRevenue` only
// fails this query, never the page.
export const GET_COACH_ANALYTICS_OTHER_REVENUE = gql`
  query CoachAnalyticsOtherRevenue(
    $timeRange: PGACoachAnalyticsTimeRangeInput
  ) {
    pgaCoachAnalytics(timeRange: $timeRange) {
      earnings {
        otherRevenue
      }
    }
  }
`
